<div class="bo-dialog">


<header class="bo-dialog__head"><span class="bo-dialog__icon"><i class="bi bi-images" aria-hidden="true"></i></span><div class="bo-dialog__heading"><h2 id="product-media-title">{{ 'ml_picker_title' | translate }}</h2><p id="product-media-description">{{ 'bd_media_description' | translate }}</p></div><button type="button" class="bo-dialog__close" [attr.aria-label]="'ac_close' | translate" (click)="activeModal.dismiss('cancelled')"><i class="bi bi-x-lg" aria-hidden="true"></i></button></header>

<div class="bo-dialog__body bo-product-media-body">

  <!-- La biblioteca va primera y es la pestana por defecto: es la novedad y es lo que el
       usuario necesita ver para poder decidir. Subir del equipo sigue a un clic. -->
  <ul class="nav nav-tabs mp-tabs" role="tablist">
    <li class="nav-item" role="presentation">
      <button type="button" class="nav-link" [class.active]="activeTab === 'library'"
        (click)="setTab('library')">
        <i class="bi bi-collection me-1"></i>{{ 'ml_picker_from_library' | translate }}
      </button>
    </li>
    <li class="nav-item" role="presentation">
      <button type="button" class="nav-link" [class.active]="activeTab === 'device'"
        (click)="setTab('device')">
        <i class="bi bi-laptop me-1"></i>{{ 'ml_picker_from_device' | translate }}
      </button>
    </li>
  </ul>

  <!-- Biblioteca: se reutiliza la misma rejilla de la pantalla, en modo seleccion. -->
  <div *ngIf="activeTab === 'library'" class="mp-library">
    <app-media-library [siteId]="siteId" [selectionMode]="true" [forcedType]="forcedType"
      (selected)="onLibrarySelected($event)" (uploadRequested)="setTab('device')">
    </app-media-library>
  </div>

  <!-- Equipo: solo recoge el fichero. La validacion y la subida las hace quien abrio este
       modal, reutilizando su flujo de siempre. Acepta clic y arrastrar y soltar. -->
  <div *ngIf="activeTab === 'device'" class="mp-device">
    <label class="mp-device__drop" [class.mp-device__drop--dragging]="isDragging" for="mpDeviceInput"
      (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">
      <i class="bi mp-device__icon" [ngClass]="isDragging ? 'bi-box-arrow-in-down' : 'bi-file-earmark-arrow-up'"></i>
      <p class="mp-device__text">
        {{ (isDragging ? 'ml_picker_drop_now' : 'ml_picker_device_hint') | translate }}
      </p>
      <button type="button" (click)="deviceFile.click(); $event.preventDefault()" class="bo-dialog__button bo-dialog__button--primary">{{ 'ml_picker_browse' | translate }}</button>
    </label>
    <p *ngIf="dropError" class="mp-device__error">
      <i class="bi bi-exclamation-triangle me-1"></i>{{ dropError }}
    </p>
    <input #deviceFile id="mpDeviceInput" type="file" class="d-none"
      [accept]="accept" [multiple]="multiple"
      (change)="onDeviceFileSelected($event)">
  </div>

</div>

<div class="bo-dialog__foot">
  <button type="button" class="bo-dialog__button" (click)="activeModal.dismiss('cancelled')">
    {{ 'ac_cancel' | translate }}
  </button>
</div>

</div>
